import React from "react";
import "./name.css";

const Name = () => {
  return (
    <div className="name">
      <h1>Berat UÇAR</h1>
      <span>Jr. Front-End Developer</span>
    </div>
  );
};

export default Name;
